import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GtLocalStorageService {
  username: string;

  getItem(key: string): string {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string) {
    if (key === 'user') {
      // Optimizing for the get/set user item
      this.getAndSetUsername(value);
    }
    localStorage.setItem(key, value);
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  getUserItem(key: string): string | null {
    return localStorage.getItem(this.getUserKey(key));
  }

  setUserItem(key: string, value: string) {
    localStorage.setItem(this.getUserKey(key), value);
  }

  removeUserItem(key: string) {
    localStorage.removeItem(this.getUserKey(key));
  }

  removeAll() {
    localStorage.clear();
  }

  getUsername(): string {
    return this.username || this.getAndSetUsername();
  }

  getUserKey(key: string): string {
    return `${this.getUsername()}-${key}`;
  }

  getAndSetUsername(value?: string): string {
    try {
      const userData = value ? JSON.parse(value) : JSON.parse(this.getItem('user'));
      this.username = !!userData ? userData.login : 'unknown';
      return this.username;
    } catch (error) {
      console.log(error);
      return '';
    }
  }
}
